import { envConfig } from 'config';
import request from 'utils/request';

const API_BASE_URL = `${envConfig.API_BASE}/api`;

// v1 endpoints (legacy)
export function getUserRequest(userId, options = {}) {
  return request(`${API_BASE_URL}/v1/users/login/${userId}`, {
    method: 'GET',
    ...options,
  });
}

// v2 endpoints
export function createUserRequest({ id, email }, options = {}) {
  return request(`${API_BASE_URL}/v2/users`, {
    method: 'POST',
    body: {
      id,
      email,
    },
    ...options,
  });
}

export function assignUserRolesToApplicationRequest(userId, applicationId, roles, options = {}) {
  return request(`${API_BASE_URL}/v2/users/${userId}/applications/${applicationId}/roles`, {
    method: 'PUT',
    body: {
      roles,
    },
    ...options,
  });
}

export function getUserRolesByApplicationRequest(userId, applicationId, options = {}) {
  return request(`${API_BASE_URL}/v2/users/${userId}/applications/${applicationId}/roles`, {
    method: 'GET',
    ...options,
  });
}

export function removeUserFromApplicationRequest(userId, applicationId, options = {}) {
  return request(`${API_BASE_URL}/v2/users/${userId}/applications/${applicationId}`, {
    method: 'DELETE',
    ...options,
  });
}

export function deleteUserRequest(userId, appID, options = {}) {
  return request(`${API_BASE_URL}/v2/users/${userId}/applications/${appID}`, {
    method: 'DELETE',
    ...options,
  });
}
